<div class="flex h-screen flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-100">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img src="../../../assets/tiktok-middle.svg" alt="Your Company" class="mx-auto h-20 w-auto"/>
    <h2 class="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Connect TikTok Account
    </h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px] flex-1 bg-gray-100">
    <div
        class="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10">
      <div class="space-y-6">


        @if (!fetchingAccount) {
          <div>
            <label for="tiktokHandle" class="block text-sm/6 font-medium text-gray-900 dark:text-white">TikTok
              Handle</label>
            <div class="mt-2 grid grid-cols-1">
              <input id="tiktokHandle" type="text" name="tiktokHandle" placeholder="TikTok Handle"
                     [(ngModel)]="tiktokHandle" (input)="errorMessage = undefined"
                     (keyup.enter)="connectTikTok()"
                     class="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pl-9 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"/>

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor"
                   class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4 dark:text-gray-500">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"/>
              </svg>

            </div>
            @if (errorMessage) {
              <p id="email-error" class="mt-2 text-sm text-red-600 dark:text-red-400">{{ errorMessage }}</p>
            }
          </div>


          <div>
            <button type="submit" (click)="connectTikTok()" [disabled]="!(tiktokHandle?.trim()?.length)"
                    class="btn-connect">
              Connect
            </button>
          </div>
        } @else {
          <div class="text-center">
            <svg aria-hidden="true"
                 class="mx-auto w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-700"
                 viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"/>
              <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"/>
            </svg>

            <h3 class="mt-2 text-sm font-semibold text-gray-900">Loading...</h3>
            <p class="mt-1 text-sm text-gray-500">One moment please...</p>
          </div>
        }
      </div>


    </div>

    @if (!fetchingAccount) {
      <p class="mt-10 text-center text-sm/6 text-gray-500 dark:text-gray-400">
        Other platforms?
        <a (click)="goBack()"
           class="font-semibold text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300">Go
          back</a>
      </p>
    }


  </div>
</div>